module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "page-foobar-detail"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('clearfix', {
    attrs: {
      "biggest": true
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 content fb-bg-light"
  }, [_c('loading-spinner')], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 content fb-bg-dark"
  }, [_c('h3', [_vm._v(_vm._s(_vm.foobar.title))])]), _vm._v(" "), _c('clearfix', {
    attrs: {
      "wide": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 content fb-bg-light"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.foobar.description)
    }
  })]), _vm._v(" "), _c('clearfix', {
    attrs: {
      "wide": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 content fb-bg-light"
  }, [_c('div', [_c('vue-markdown', {
    attrs: {
      "source": _vm.foobar.md,
      "lang-prefix": "hljs "
    }
  })], 1)])], 1), _vm._v(" "), _vm._l((_vm.sortedSnippets), function(snippet) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.loading && _vm.foobar.snippets.length > 0),
        expression: "!loading && foobar.snippets.length > 0"
      }],
      staticClass: "row"
    }, [_c('clearfix', {
      attrs: {
        "wide": true
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 content fb-bg-light"
    }, [_c('a', {
      attrs: {
        "name": snippet.id
      }
    }), _vm._v(" "), _c('h4', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (snippet.title.length > 0),
        expression: "snippet.title.length > 0"
      }]
    }, [_vm._v(_vm._s(snippet.title))]), _vm._v(" "), _c('div', [_c('pre', {
      directives: [{
        name: "highlightjs",
        rawName: "v-highlightjs",
        value: (snippet.content),
        expression: "snippet.content"
      }]
    }, [_c('code', {
      class: snippet.lang
    })])])])], 1)
  }), _vm._v(" "), _c('clearfix', {
    attrs: {
      "wide": true
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading && _vm.foobar.tags.length > 0),
      expression: "!loading && foobar.tags.length > 0"
    }],
    staticClass: "row"
  }, [_c('clearfix', {
    attrs: {
      "wide": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 content fb-bg-light"
  }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('message.title.tags')) + ": ")]), _vm._l((_vm.foobar.tags), function(tag) {
    return _c('b-button', {
      staticClass: "fb-tag",
      attrs: {
        "size": 'sm',
        "variant": 'secondary'
      }
    }, [_vm._v(_vm._s(tag))])
  })], 2)])], 1), _vm._v(" "), _c('clearfix', {
    attrs: {
      "biggest": true
    }
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11cf4d6a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/foobar/Foobar.vue
// module id = 1822
// module chunks = 1